import http from '@/http/http-common'

const state = {}
const mutations = {}
const getters = {}

const actions = {
    getUnits({ commit }, companyId) {
        //// console.log('getUnitsAsList Commit', options, http)

        commit('setLoadingState', true)

        http.get('resource/units/getUnitList/' + companyId)
            .then(res => {
                commit('setUnits', res.data)
            })
            .finally(() => {
                commit('setLoadingState', false)
            })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}

/**

{
  "url": "/resource/departments",
  "method": "GET",
  "params": {
    "filter": {
      "company_id": "A386D062-BD0D-435E-AA32-441697D78ECA"
    }
  },
  "headers": {}
}
*/
